<div class="toast-container" [ngClass]="loadPosition()" [class.active]="show">
  <div [ngStyle]="style" class="ng-toast" [ngClass]="loadMessageType()">
    <div class="container-1">
      <i class="fa" [ngClass]="loadIconType()"></i>
    </div>
    <div class="container-2">
      <p>{{ toastDetails?.detail }}</p>
      <p>{{ toastDetails?.summary }}</p>
    </div>
    <button *ngIf="show" id="close" (click)="closeToast()">&times;</button>
  </div>
</div>
